import { render, staticRenderFns } from "./POForm.vue?vue&type=template&id=6681584d&"
import script from "./POForm.vue?vue&type=script&lang=js&"
export * from "./POForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports